import { useDaemonDecision } from '../../hooks/useDaemonDecision.js';
import { Modal } from '../ui/Modal.js';
import { DecisionReview } from './DecisionReview.js';

/**
 * Reviews one pending daemon decision outside a conversation (opened from the header's "Waiting on you").
 * The server decides who may review (`review.canReview`); the buttons appear only for that person. The review itself is
 * `DecisionReview`, which a conversation's side panel shows too.
 */
export function DecisionReviewDialog({ decisionId, onClose }: { decisionId: number | null; onClose: () => void }) {
  const { decision } = useDaemonDecision(decisionId);
  const open = decisionId !== null;

  return (
    // The shared Modal bounds the dialog to the window and scrolls its body: a long request no longer pushes the
    // title and the Approve / Reject buttons off screen.
    <Modal
      open={open}
      onClose={onClose}
      title={decision?.title ?? 'Request'}
      description="A decision only a person can make."
      maxWidth="xl"
    >
      {decisionId !== null && <DecisionReview decisionId={decisionId} onDone={onClose} />}
    </Modal>
  );
}
